import { render, staticRenderFns } from "./tv-commands.vue?vue&type=template&id=6c061b88&"
import script from "./tv-commands.vue?vue&type=script&lang=ts&"
export * from "./tv-commands.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports